import { render, staticRenderFns } from "./updateConsigneeInfo.vue?vue&type=template&id=132670bf&scoped=true"
import script from "./updateConsigneeInfo.vue?vue&type=script&lang=js"
export * from "./updateConsigneeInfo.vue?vue&type=script&lang=js"
import style0 from "./updateConsigneeInfo.vue?vue&type=style&index=0&id=132670bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132670bf",
  null
  
)

export default component.exports